<template>
    <div class="ui-content dashboard">
        <div class="institute-drop">
            <div class="past-test-dropdown" v-if="students.length > 1 && isParent">
                <v-select
                    @change="updateSelectedStudent"
                    :items="students"
                    v-model="selectedStudent"
                    hide-details
                ></v-select>
            </div>
        </div>
        <div class="page-user user my-healt-hg">
                        <v-card class="mx-auto normal-card PerChapterHealth">
                            <PerChapterHealth
                                :selectedSubject="selectedSubject"
                                :studentId="studentId"
                            />
                        </v-card>
        </div>
    </div>
</template>

<script>
import PerChapterHealth from "@/components/student/health/PerChapterHealth.vue";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
    name: "ChaptersHealth",
    components: {
        PerChapterHealth
    },
    mounted() {
        let subject = this.$route.params.subject_name;
        this.addBreadCrumbChilde([
                {
                    text: subject ? subject : "",
                    disabled: false
                }
            ]);
        if (this.user.role_id == this.roleIds.PA) {
            this.initStudentData();
        } else {
            this.studentId = this.user.id;
            // this.getSubject()
            this.getStudentHealth();

        }
    },
    computed: {
        ...mapState("userStore", ["user"])
    },

    data() {
        return {
            icons: false,
            centered: false,
            grow: false,
            breadcrumbSubject: "",
            vertical: false,
            prevIcon: false,
            nextIcon: false,
            right: false,
            tab: null,
            students: [],
            selectedStudent: [],
            studentId: null,
            isParent: false,
            subjects: [],
            paramSubject: {},
            subject_two:[],
            selectedSubject: {},
            chartOptions: {
                chart: {
                    type: "pie"
                },
                labels: [],
                legend: {
                    show: false
                },
                fill: {},
                tooltip: {
                    enabled: false
                },
                dataLabels: {
                    enabled: false
                },
                states: {
                    hover: {
                        filter: {
                            type: "none"
                        }
                    }
                },
                tooltip: {
                    enabled: false
                }
            }
        };
    },
    methods: {
        ...mapActions({
            setSelectedSubjectData: "healthStore/setSelectedSubjectData",
            getMyHealthData: "healthStore/getMyHealthData",
            getStudentSubjectTree: "resultStore/getStudentSubjectTree",
            getChildren: "resultStore/getChildren",
        }),
        ...mapMutations("app", ["addBreadCrumbChilde"]),
        defaultData() {
            let crd = this.getCurrentRouteDetails('my-health'); 
            if(crd) {
                this.tab = crd.selectedTab ? crd.selectedTab : 0;
            }
        },        
        checkSessionData() {
            let crd = this.getCurrentRouteDetails('my-health');
            
            if(!crd.routeName) {            
                let routeDetails = {
                    routeName: 'my-health',
                    selectedTab: this.tab,
                }
                this.setRouteDetails(routeDetails);
            }
        },
        updateSelectedStudent() {
            this.studentId = this.selectedStudent.id;
            let crd = this.getCurrentRouteDetails('my-health');
            crd.selectedStudent = this.selectedStudent;
            this.setRouteDetails(crd);
            // this.getSubject();
            this.getStudentHealth();
        },
        initStudentData() {
            this.isParent = true;
            this.students = this.user.students.map(student => {
                let studentObj = {
                    text: student.name,
                    value: {
                        id: student.id,
                        batchId: student.batch_id
                    }
                };
                return studentObj;
            });
            let crd = this.getCurrentRouteDetails('my-health');
            this.selectedStudent = crd && crd.selectedStudent ? crd.selectedStudent : this.getSelectedStudent();
            this.studentId = this.selectedStudent.id;
            this.getStudentHealth();
        },
        getSelectedStudent() {
            let studentId = this.$route.params.student_id;
            let selectedStudent = this.students.find(s => s.value.id == studentId);
            return selectedStudent ? selectedStudent.value : this.student[0].value;
        },
        getColor(percentage) {
            let color = "";
            if (percentage > 65) {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.GREEN;
            } else if (percentage > 19) {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.ORANGE;
            } else {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.RED;
            }
            return color;
        },
        getStudentHealth(subject) {
            this.$root.showLoader = true;
            let me = this;
              let  reqData = {
                    "student_id": this.user.id,
                    "subject_id":this.$route.params.subject_id
                }
                if(this.isParent){
                    reqData.student_id = this.studentId
                }
                this.getStudentSubjectTree(reqData)
                .then(response => {
                    if (response.length > 0) {
                    this.processHealthData(response);
                    }
                    this.$root.showLoader = false;
                    me.defaultData();
                    me.checkSessionData();
                })
                .catch(err => {
                    me.$root.showLoader = false;
                });
            

        },
        processHealthData(response) {
            let subjectObj = {}
            if(response.length > 0) {
                let currentSubject = response[0];
                subjectObj.name =currentSubject.title;
                subjectObj.id = currentSubject.id;
                subjectObj.health = currentSubject.health;
                subjectObj.chapters = [];
                this.subjects.name = currentSubject.title;
                this.subjects.id = currentSubject.id;
                if(currentSubject.chidren.length > 0) {
                    currentSubject.chidren.map(c =>{
                        let chapterObj = {}
                        chapterObj.name = c.title;
                        chapterObj.id = c.id;
                        chapterObj.health = c.health;
                        subjectObj.chapters.push(chapterObj)
                    })
                }
                
            }
             this.selectedSubject = subjectObj;
        },
    },
    watch: {
        tab(val, oldVal) {
            if(oldVal) { // only when tab is changed and not on page load
                let routeName = this.$route.name;
                this.setRouteDetails({routeName, selectedTab: val});
                this.getStudentHealth(this.subjects[val]);
            }
            let subject = this.$route.params.subject_name;
            this.addBreadCrumbChilde([
                {
                    text: subject ? subject : "",
                    disabled: false
                }
            ]);
        }
    }
};
</script>